import React, { useState } from 'react';



// WhatsApp Button Component
const WhatsAppButton = () => {
  const phoneNumber = "25472050618"; // Replace with actual WhatsApp number
  const message = "Hello! I'm interested in your services.";
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      style={{
        position: 'fixed',
        bottom: '24px',
        left: '24px',
        backgroundColor: '#10b981',
        color: 'white',
        padding: '16px',
        borderRadius: '50%',
        boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)',
        transition: 'all 0.3s',
        zIndex: 50,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        textDecoration: 'none'
      }}
      onMouseOver={(e) => e.target.style.backgroundColor = '#059669'}
      onMouseOut={(e) => e.target.style.backgroundColor = '#10b981'}
      aria-label="Contact us on WhatsApp"
    >
      <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.451 3.488"/>
      </svg>
    </a>
  );
};

// Menu Icons
const HiMenu = () => (
  <svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="3" y1="6" x2="21" y2="6"></line>
    <line x1="3" y1="12" x2="21" y2="12"></line>
    <line x1="3" y1="18" x2="21" y2="18"></line>
  </svg>
);

const HiX = () => (
  <svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="18" y1="6" x2="6" y2="18"></line>
    <line x1="6" y1="6" x2="18" y2="18"></line>
  </svg>
);

const navItems = [
  { label: 'Home', href: '#' },
  { label: 'About', href: '#about' },
  { label: 'Services', href: '#services' },
  { label: 'Testimonials', href: '#testimonials' },
  { label: 'Contact', href: '#contact' },
];

const NavLink = ({ href, children }) => {
  const handleClick = (e) => {
    e.preventDefault();
    if (href === '#') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      const element = document.querySelector(href);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  return (
    <a
      href={href}
      onClick={handleClick}
      style={{
        position: 'relative',
        display: 'inline-block',
        padding: '8px 12px',
        fontWeight: '500',
        transition: 'all 0.3s',
        color: '#2563eb',
        textDecoration: 'none',
        borderRadius: '4px',
        cursor: 'pointer'
      }}
      onMouseOver={(e) => e.target.style.color = '#1e40af'}
      onMouseOut={(e) => e.target.style.color = '#2563eb'}
    >
      {children}
    </a>
  );
};

const Hero = () => (
  <section
    id="home"
    style={{
      position: 'relative',
      width: '100%',
      minHeight: '100vh',
      paddingTop: '96px',
      background: 'linear-gradient(135deg, #f59e0b 0%, #1d4ed8 100%)',
      color: 'white',
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden'
    }}
  >
    <div style={{
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundImage: "url('/hero-bg.jpg')",
      backgroundPosition: 'center',
      backgroundSize: 'cover',
      opacity: 0.3,
      mixBlendMode: 'overlay'
    }} />
    
    {/* Navigation */}
    <nav style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      zIndex: 10,
      backgroundColor: 'white',
      borderBottom: '1px solid #d1d5db',
      boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)'
    }}>
      <div style={{
        maxWidth: '1200px',
        margin: '0 auto',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '16px 16px',
      }}>
        <img
          src="/logo.png "
          alt="Logo"
          style={{
            height: '68px',
            width: '160px'
          }}
        />
        <ul style={{
          display: 'none',
          gap: '24px',
          listStyle: 'none',
          margin: 0,
          padding: 0,
          '@media (min-width: 768px)': {
            display: 'flex'
          }
        }}>
          {navItems.map((item) => (
            <li key={item.label}>
              <NavLink href={item.href}>{item.label}</NavLink>
            </li>
          ))}
        </ul>
      </div>
    </nav>

    <div style={{
      position: 'relative',
      zIndex: 10,
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'center',
      padding: '0 16px'
    }}>
      <h2 style={{
        fontSize: '3rem',
        fontWeight: 'bold',
        lineHeight: 1.2,
        marginBottom: '24px',
        '@media (min-width: 768px)': {
          fontSize: '4.5rem'
        }
      }}>
        Ignite Your Brand. Conquer New Peaks.
      </h2>
      <p style={{
        maxWidth: '36rem',
        fontSize: '1.125rem',
        marginBottom: '40px',
        '@media (min-width: 768px)': {
          fontSize: '1.5rem'
        }
      }}>
        At PeakFluence, we don't just market; we spark revolutions. Let's turn your story into
        unstoppable influence.
      </p>
      <h2 style={{
        fontSize: '3rem',
        fontWeight: 'bold',
        lineHeight: 1.2,
        marginBottom: '24px',
        '@media (min-width: 768px)': {
          fontSize: '4.5rem'
        }
      }}>
        Let's Elevate Your Brand
      </h2>
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        '@media (min-width: 640px)': {
          flexDirection: 'row'
        }
      }}>
        <a href="#services" 
           onClick={(e) => {
             e.preventDefault();
             document.querySelector('#services').scrollIntoView({ behavior: 'smooth' });
           }}
           style={{ textDecoration: 'none' }}>
          <button style={{
            padding: '16px 32px',
            backgroundColor: 'white',
            color: '#1d4ed8',
            fontWeight: '600',
            borderRadius: '50px',
            boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)',
            border: 'none',
            cursor: 'pointer',
            transition: 'all 0.3s',
            transform: 'translateY(0)'
          }}
          onMouseOver={(e) => {
            e.target.style.boxShadow = '0 20px 25px -5px rgba(0, 0, 0, 0.1)';
            e.target.style.transform = 'translateY(-4px)';
          }}
          onMouseOut={(e) => {
            e.target.style.boxShadow = '0 10px 15px -3px rgba(0, 0, 0, 0.1)';
            e.target.style.transform = 'translateY(0)';
          }}>
            Our Services
          </button>
        </a>
        <a href="#about"
           onClick={(e) => {
             e.preventDefault();
             document.querySelector('#about').scrollIntoView({ behavior: 'smooth' });
           }}
           style={{ textDecoration: 'none' }}>
          <button style={{
            padding: '16px 32px',
            border: '2px solid white',
            backgroundColor: 'transparent',
            color: 'white',
            fontWeight: '600',
            borderRadius: '50px',
            cursor: 'pointer',
            transition: 'all 0.3s'
          }}
          onMouseOver={(e) => {
            e.target.style.backgroundColor = 'white';
            e.target.style.color = '#1d4ed8';
          }}
          onMouseOut={(e) => {
            e.target.style.backgroundColor = 'transparent';
            e.target.style.color = 'white';
          }}>
            Learn More
          </button>
        </a>
      </div>
    </div>

    {/* Scroll Down Indicator */}
    <div style={{
      position: 'absolute',
      bottom: '32px',
      left: '50%',
      transform: 'translateX(-50%)',
      animation: 'bounce 1.5s infinite'
    }}>
      <svg width="32" height="32" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M16 8v16M24 16l-8 8-8-8" />
      </svg>
    </div>
  </section>
);

const App = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  // Define the pricing plans array
  const plans = [
    {
      name: "Starter Plan",
      price: "Ksh 15,000",
      features: [
        "Social Media Management (2 platforms: Facebook & Instagram)",
        "10 custom posters per month",
        "2 targeted ad campaigns per month",
        "Monthly performance report & insights",
      ],
    },
    {
      name: "Growth Plan",
      price: "Ksh 30,000",
      features: [
        "Social Media Management (4 platforms: Facebook, Instagram, LinkedIn, Twitter)",
        "20 custom posters per month",
        "4 targeted ad campaigns per month",
        "Monthly performance report & strategy consultation",
      ],
    },
    {
      name: "Premium Plan",
      price: "Ksh 60,000",
      features: [
        "Social Media Management (all major platforms: Facebook, Instagram, LinkedIn, Twitter, TikTok)",
        "30 custom posters per month",
        "6 highly optimized ad campaigns per month",
        "Bi-weekly performance report & in-depth consultation",
      ],
    },
    {
      name: "Business Starter Package",
      price: "Ksh 75,000",
      features: [
        "Creation and setup of social media pages (Facebook, Instagram, LinkedIn, Twitter, TikTok)",
        "Custom branding (Profile & Cover Images, Bio Optimization)",
        "10 introductory posts to establish brand presence",
        "Basic Website Development",
        "Company Profile Portfolio"
      ],
    },
    {
      name: "Website Development",
      price: "Ksh 25,000",
      features: [
        "Social Media Management (all platforms)",
        "30 custome posters per month",
        "6 highly optimized ad campaigns per month",
       "Bi-weekly performance report & in-depth consultation",
      ],
    },
    {
      name: "Corporate Digital Domination",
      price: "Ksh 150,000",
      features: [
       "Social Media Management (all platforms)",
       "Email Marketing Campaigns",
       "40+ custom poster",
       "Influencer Marketing Strategy",
       "Adanced SEO Strategy",
       "PPC Advertising (Google Ads & Youtube)",
       "Website Optimization & E-commerce Integration And Advance Analytics",
       "Consultation on Brand Positioning ", 
       "24/7 Priority Support",
      ],
    },
  ];

  const handleContactClick = (e) => {
    e.preventDefault();
    document.querySelector('#contact').scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <>
      <style>
        {`
          @keyframes bounce {
            0%, 100% { transform: translateX(-50%) translateY(0); }
            50% { transform: translateX(-50%) translateY(-10px); }
          }
          
          @media (min-width: 768px) {
            .nav-desktop {
              display: flex !important;
            }
            .mobile-menu-btn {
              display: none !important;
            }
          }
          
          * {
            box-sizing: border-box;
          }
          
          body {
            margin: 0;
            font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
          }
        `}
      </style>
      
      <Hero />

      {/* Mobile Drawer */}
      {menuOpen && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            right: 0,
            width: '256px',
            height: '100%',
            backgroundColor: 'white',
            boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)',
            zIndex: 20,
            padding: '24px',
            display: 'flex',
            flexDirection: 'column',
            transform: menuOpen ? 'translateX(0)' : 'translateX(100%)',
            transition: 'transform 0.3s ease'
          }}
        >
          <button 
            onClick={() => setMenuOpen(false)} 
            style={{
              alignSelf: 'flex-end',
              marginBottom: '32px',
              background: 'none',
              border: 'none',
              cursor: 'pointer'
            }}
          >
            <HiX />
          </button>
          <nav style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
            {navItems.map((item) => (
              <a
                key={item.label}
                href={item.href}
                onClick={(e) => {
                  e.preventDefault();
                  setMenuOpen(false);
                  if (item.href === '#') {
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                  } else {
                    const element = document.querySelector(item.href);
                    if (element) {
                      element.scrollIntoView({ behavior: 'smooth' });
                    }
                  }
                }}
                style={{
                  fontSize: '1.25rem',
                  fontWeight: '500',
                  color: '#1f2937',
                  textDecoration: 'none',
                  cursor: 'pointer'
                }}
                onMouseOver={(e) => e.target.style.color = '#2563eb'}
                onMouseOut={(e) => e.target.style.color = '#1f2937'}
              >
                {item.label}
              </a>
            ))}
          </nav>
        </div>
      )}

      {/* Mobile Menu Button */}
      <button
        className="mobile-menu-btn"
        onClick={() => setMenuOpen(true)}
        style={{
          position: 'fixed',
          bottom: '24px',
          right: '24px',
          backgroundColor: '#2563eb',
          color: 'white',
          padding: '16px',
          borderRadius: '50%',
          boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)',
          border: 'none',
          cursor: 'pointer',
          zIndex: 20,
          display: window.innerWidth < 768 ? 'block' : 'none'
        }}
      >
        <HiMenu />
      </button>

      <section id="about" style={{
        padding: '96px 0',
        backgroundColor: 'white',
        color: '#1f2937'
      }}>
        <div style={{
          maxWidth: '1200px',
          margin: '0 auto',
          padding: '0 16px',
          textAlign: 'center'
        }}>
          <h2 style={{
            fontSize: '3rem',
            fontWeight: 'bold',
            lineHeight: 1.2,
            marginBottom: '24px',
            '@media (min-width: 768px)': {
              fontSize: '4.5rem'
            }
          }}>
            Born to Build Legends
          </h2>
          <p style={{
            maxWidth: '48rem',
            margin: '0 auto',
            fontSize: '1.125rem',
            lineHeight: 1.6,
            '@media (min-width: 768px)': {
              fontSize: '1.25rem'
            }
          }}>
            At PeakFluence, we believe marketing is not just about selling; it's about stirring souls.
            We are a new breed of marketing agency, built for ambitious brands that refuse to be average.
            Powered by passion, creativity and Kenyan resilience, we help businesses rise above the noise;
            and stay unforgettable.
            Whether you're a bold startup or an empire in the making, PeakFluence is your launchpad.
          </p>
        </div>
      </section>

      {/* Services Section */}
      <section
        id="services"
        style={{
          padding: '80px 0',
          backgroundColor: '#f9fafb',
          color: '#1f2937'
        }}
      >
        <div style={{
          maxWidth: '1200px',
          margin: '0 auto',
          padding: '0 16px'
        }}>
          <h3 style={{
            fontSize: '2.5rem',
            fontWeight: 'bold',
            textAlign: 'center',
            marginBottom: '48px',
            '@media (min-width: 1024px)': {
              fontSize: '3rem'
            }
          }}>
            Our Services
          </h3>
          <div style={{
            display: 'grid',
            gap: '32px',
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))'
          }}>
            {[
              {
                icon: "📈",
                title: "Marketing Solutions for the Modern Brand",
                subtitle: "Full-Spectrum & Tailored",
                items: [
                  "Digital & Social Media Marketing",
                  "SEO & Website Design",
                  "Experiential Campaigns",
                  "Influencer Marketing",
                  "E-commerce Development",
                  "PPC (Google & YouTube Ads)",
                ],
              },
              {
                icon: "💻",
                title: "Digital Marketing",
                subtitle: "Strategic. Creative. Targeted.",
                items: [
                  "Paid Ads (Google, YouTube, Display & Search)",
                  "Social Media Campaigns",
                  "Custom Content Creation",
                  "Email Marketing",
                  "Analytics & Reporting",
                ],
              },
              {
                icon: "🌐",
                title: "Websites",
                subtitle: "Your Digital Storefront – Designed to Convert",
                items: [
                  "Custom Headers & CTAs",
                  "Blog & Social Media Integration",
                  "WhatsApp Chat Plug-in",
                  "Lead Capture Forms",
                  "On-page SEO & Speed Optimization",
                ],
              },
              {
                icon: "🔍",
                title: "SEO",
                subtitle: "Be Found. Stay Relevant. Grow Organically.",
                items: [
                  "Keyword Research & Analysis",
                  "Technical & On-page SEO",
                  "Local SEO Optimization",
                  "Blog & Link Building",
                  "Performance Audits",
                ],
              },
              {
                icon: "🎯",
                title: "Experiential Marketing",
                subtitle: "Engage Offline. Amplify Online.",
                items: [
                  "Event Branding & Setup",
                  "Influencer Takeovers",
                  "Roadshows & Pop-up Experiences",
                  "Compliance & Logistics Support",
                  "Cross-platform Digital Promotion",
                ],
              },
            ].map((svc, i) => (
              <div
                key={svc.title}
                style={{
                  backgroundColor: 'white',
                  padding: '32px',
                  borderRadius: '16px',
                  boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
                  transition: 'box-shadow 0.3s',
                  display: 'flex',
                  flexDirection: 'column',
                  height: '100%'
                }}
                onMouseOver={(e) => e.currentTarget.style.boxShadow = '0 20px 25px -5px rgba(0, 0, 0, 0.1)'}
                onMouseOut={(e) => e.currentTarget.style.boxShadow = '0 4px 6px -1px rgba(0, 0, 0, 0.1)'}
              >
                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '16px' }}>
                  <span style={{ fontSize: '2.5rem' }}>{svc.icon}</span>
                  <h4 style={{
                    marginLeft: '12px',
                    fontSize: '1.25rem',
                    fontWeight: 'bold',
                    color: '#2563eb',
                    margin: '0 0 0 12px'
                  }}>
                    {svc.title}
                  </h4>
                </div>
                <p style={{
                  fontStyle: 'italic',
                  color: '#6b7280',
                  marginBottom: '16px'
                }}>
                  {svc.subtitle}
                </p>
                <ul style={{
                  listStyle: 'none',
                  padding: 0,
                  margin: 0,
                  flex: 1,
                  color: '#374151'
                }}>
                  {svc.items.map((item) => (
                    <li key={item} style={{
                      display: 'flex',
                      alignItems: 'flex-start',
                      marginBottom: '8px'
                    }}>
                      <span style={{ marginRight: '8px', color: '#3b82f6' }}>•</span>
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Pricing Section */}
      <section id="pricing" style={{
        padding: '96px 0',
        backgroundColor: '#f9fafb',
        color: '#1f2937'
      }}>
        <div style={{
          maxWidth: '1200px',
          margin: '0 auto',
          padding: '0 16px'
        }}>
          <h3 style={{
            fontSize: '2.5rem',
            fontWeight: 'bold',
            marginBottom: '48px',
            textAlign: 'center',
            '@media (min-width: 768px)': {
              fontSize: '3rem'
            }
          }}>
            Our Pricing Plans
          </h3>
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
            gap: '32px'
          }}>
            {plans.map((plan, index) => (
              <div
                key={plan.name}
                style={{
                  backgroundColor: 'white',
                  padding: '24px',
                  borderRadius: '16px',
                  boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
                  transition: 'box-shadow 0.3s',
                  display: 'flex',
                  flexDirection: 'column'
                }}
                onMouseOver={(e) => e.currentTarget.style.boxShadow = '0 10px 15px -3px rgba(0, 0, 0, 0.1)'}
                onMouseOut={(e) => e.currentTarget.style.boxShadow = '0 4px 6px -1px rgba(0, 0, 0, 0.1)'}
              >
                <h4 style={{
                  fontSize: '1.5rem',
                  fontWeight: 'bold',
                  marginBottom: '8px'
                }}>{plan.name}</h4>
                <p style={{
                  fontSize: '1.875rem',
                  fontWeight: '600',
                  color: '#2563eb',
                  marginBottom: '16px'
                }}>{plan.price}</p>
                <ul style={{
                  listStyle: 'none',
                  padding: 0,
                  marginBottom: '24px',
                  flex: 1
                }}>
                  {plan.features.map((feature) => (
                    <li key={feature} style={{
                      display: 'flex',
                      alignItems: 'flex-start',
                      marginBottom: '8px'
                    }}>
                      <span style={{ color: '#10b981', marginRight: '8px' }}>✓</span>
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
                <a href="#contact" onClick={handleContactClick} style={{ textDecoration: 'none' }}>
                 
                </a>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section id="testimonials" style={{
        padding: '96px 0',
        backgroundColor: 'white',
        color: '#1f2937'
      }}>
        <div style={{
          maxWidth: '1200px',
          margin: '0 auto',
          padding: '0 16px'
        }}>
          <h3 style={{
            fontSize: '2.5rem',
            textAlign: 'center',
            fontWeight: 'bold',
            marginBottom: '48px',
            '@media (min-width: 768px)': {
              fontSize: '3rem'
            }
          }}>
            The Brands We've Launched to the Top
          </h3>
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
            gap: '32px'
          }}>
            <div style={{
              backgroundColor: '#f9fafb',
              padding: '24px',
              borderRadius: '16px',
              boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
              transition: 'box-shadow 0.3s'
            }}
            onMouseOver={(e) => e.currentTarget.style.boxShadow = '0 10px 15px -3px rgba(0, 0, 0, 0.1)'}
            onMouseOut={(e) => e.currentTarget.style.boxShadow = '0 4px 6px -1px rgba(0, 0, 0, 0.1)'}>
              <p style={{
                fontStyle: 'italic',
                color: '#374151',
                marginBottom: '16px'
              }}>"PeakFluence turned our small dream into a movement. They don't just market, they believe in you."</p>
              <p style={{
                fontWeight: '600',
                color: '#1d4ed8'
              }}>Wanjiku - Founder, Thrive Kenya</p>
            </div>
            <div style={{
              backgroundColor: '#f9fafb',
              padding: '24px',
              borderRadius: '16px',
              boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
              transition: 'box-shadow 0.3s'
            }}
            onMouseOver={(e) => e.currentTarget.style.boxShadow = '0 10px 15px -3px rgba(0, 0, 0, 0.1)'}
            onMouseOut={(e) => e.currentTarget.style.boxShadow = '0 4px 6px -1px rgba(0, 0, 0, 0.1)'}>
              <p style={{
                fontStyle: 'italic',
                color: '#374151',
                marginBottom: '16px'
              }}>"PeakFluence transformed our online presence overnight. Their energy is contagious – we truly felt like Nairobi's heartbeat was powering our campaign!"</p>
              <p style={{
                fontWeight: '600',
                color: '#1d4ed8'
              }}>Amina, CEO of Safiri Ventures</p>
            </div>
            <div style={{
              backgroundColor: '#f9fafb',
              padding: '24px',
              borderRadius: '16px',
              boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
              transition: 'box-shadow 0.3s'
            }}
            onMouseOver={(e) => e.currentTarget.style.boxShadow = '0 10px 15px -3px rgba(0, 0, 0, 0.1)'}
            onMouseOut={(e) => e.currentTarget.style.boxShadow = '0 4px 6px -1px rgba(0, 0, 0, 0.1)'}>
              <p style={{
                fontStyle: 'italic',
                color: '#374151',
                marginBottom: '16px'
              }}>"Working with PeakFluence felt like finding the perfect blend of creativity and strategy. Our brand has never been this alive!"</p>
              <p style={{
                fontWeight: '600',
                color: '#1d4ed8'
              }}>James, Founder of SlayQueen Boutique</p>
            </div>
            <div style={{
              backgroundColor: '#f9fafb',
              padding: '24px',
              borderRadius: '16px',
              boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
              transition: 'box-shadow 0.3s'
            }}
            onMouseOver={(e) => e.currentTarget.style.boxShadow = '0 10px 15px -3px rgba(0, 0, 0, 0.1)'}
            onMouseOut={(e) => e.currentTarget.style.boxShadow = '0 4px 6px -1px rgba(0, 0, 0, 0.1)'}>
              <p style={{
                fontStyle: 'italic',
                color: '#374151',
                marginBottom: '16px'
              }}>"From the first brainstorm to the final launch, PeakFluence moved mountains for our brand. It was truly a breath of fresh Nairobi air!"</p>
              <p style={{
                fontWeight: '600',
                color: '#1d4ed8'
              }}>Fatuma, Marketing Manager at Mama's Kitchen</p>
            </div>
            <div style={{
              backgroundColor: '#f9fafb',
              padding: '24px',
              borderRadius: '16px',
              boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
              transition: 'box-shadow 0.3s'
            }}
            onMouseOver={(e) => e.currentTarget.style.boxShadow = '0 10px 15px -3px rgba(0, 0, 0, 0.1)'}
            onMouseOut={(e) => e.currentTarget.style.boxShadow = '0 4px 6px -1px rgba(0, 0, 0, 0.1)'}>
              <p style={{
                fontStyle: 'italic',
                color: '#374151',
                marginBottom: '16px'
              }}>"PeakFluence didn't just understand our vision — they amplified it beyond what we thought possible!"</p>
              <p style={{
                fontWeight: '600',
                color: '#1d4ed8'
              }}>Derrick, Founder, AfriTrendz</p>
            </div>
            <div style={{
              backgroundColor: '#f9fafb',
              padding: '24px',
              borderRadius: '16px',
              boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
              transition: 'box-shadow 0.3s'
            }}
            onMouseOver={(e) => e.currentTarget.style.boxShadow = '0 10px 15px -3px rgba(0, 0, 0, 0.1)'}
            onMouseOut={(e) => e.currentTarget.style.boxShadow = '0 4px 6px -1px rgba(0, 0, 0, 0.1)'}>
              <p style={{
                fontStyle: 'italic',
                color: '#374151',
                marginBottom: '16px'
              }}>"They brought the energy, the creativity, and the strategy. Our growth numbers are proof."</p>
              <p style={{
                fontWeight: '600',
                color: '#1d4ed8'
              }}>Susan, Marketing Director, JengaPay</p>
            </div>
            <div style={{
              backgroundColor: '#f9fafb',
              padding: '24px',
              borderRadius: '16px',
              boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
              transition: 'box-shadow 0.3s'
            }}
            onMouseOver={(e) => e.currentTarget.style.boxShadow = '0 10px 15px -3px rgba(0, 0, 0, 0.1)'}
            onMouseOut={(e) => e.currentTarget.style.boxShadow = '0 4px 6px -1px rgba(0, 0, 0, 0.1)'}>
              <p style={{
                fontStyle: 'italic',
                color: '#374151',
                marginBottom: '16px'
              }}>"With PeakFluence, we found a team that roots for us like it's personal. It shows in every campaign."</p>
              <p style={{
                fontWeight: '600',
                color: '#1d4ed8'
              }}>Moses, CEO, Shwari Rides</p>
            </div>
          </div>
        </div>
      </section>

   
   {/* Contact Section */}
<section id="contact" style={{
  padding: '96px 0',
  backgroundColor: 'white',
  color: '#1f2937'
}}>
  <div style={{
    maxWidth: '512px',
    margin: '0 auto',
    padding: '0 16px'
  }}>
    <h3 style={{
      fontSize: '2.5rem',
      fontWeight: 'bold',
      marginBottom: '24px',
      textAlign: 'center',
      '@media (min-width: 768px)': {
        fontSize: '3rem'
      }
    }}>
      Get In Touch
    </h3>
    
    <form 
      id="contactForm"
      action="https://formsubmit.co/peakfluence@peakflunce.co.ke" 
      method="POST"
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '20px'
      }}
      onSubmit={async (e) => {
        e.preventDefault();
        const form = e.target;
        const formData = new FormData(form);
        
        try {
          const response = await fetch(form.action, {
            method: 'POST',
            body: formData
          });
          
          if (response.ok) {
            // Show success message
            alert('Message submitted successfully!');
            // Reset form
            form.reset();
            // Reload page after a short delay
            setTimeout(() => {
              window.location.reload();
            }, 1000);
          } else {
            alert('There was an error submitting your message. Please try again.');
          }
        } catch (error) {
          alert('There was an error submitting your message. Please try again.');
        }
      }}
    >
      <div>
        <input
          type="email"
          name="email"
          placeholder="Your email address"
          required
          style={{
            width: '100%',
            padding: '16px',
            border: '2px solid #e5e7eb',
            borderRadius: '8px',
            fontSize: '16px',
            outline: 'none',
            transition: 'border-color 0.3s',
            boxSizing: 'border-box'
          }}
          onFocus={(e) => e.target.style.borderColor = '#2563eb'}
          onBlur={(e) => e.target.style.borderColor = '#e5e7eb'}
        />
      </div>
      
      <div>
        <textarea
          name="message"
          placeholder="Your message"
          required
          rows="5"
          style={{
            width: '100%',
            padding: '16px',
            border: '2px solid #e5e7eb',
            borderRadius: '8px',
            fontSize: '16px',
            outline: 'none',
            transition: 'border-color 0.3s',
            resize: 'vertical',
            fontFamily: 'inherit',
            boxSizing: 'border-box'
          }}
          onFocus={(e) => e.target.style.borderColor = '#2563eb'}
          onBlur={(e) => e.target.style.borderColor = '#e5e7eb'}
        />
      </div>
      
      {/* FormSubmit configuration */}
      <input type="hidden" name="_captcha" value="false" />
      <input type="hidden" name="_template" value="table" />
      <input type="hidden" name="_subject" value="New Contact Form Submission from PeakFluence Website" />
      
      <div style={{
        display: 'flex',
        justifyContent: 'center'
      }}>
        <button
          type="submit"
          style={{
            padding: '16px 32px',
            backgroundColor: '#2563eb',
            color: 'white',
            fontWeight: '600',
            borderRadius: '50px',
            textDecoration: 'none',
            transition: 'background-color 0.3s',
            border: 'none',
            cursor: 'pointer',
            fontSize: '16px'
          }}
          onMouseOver={(e) => e.target.style.backgroundColor = '#1d4ed8'}
          onMouseOut={(e) => e.target.style.backgroundColor = '#2563eb'}
        >
          Send Message
        </button>
      </div>
    </form>
  </div>
</section>

      {/* Footer */}
      <footer style={{
        padding: '32px 0',
        backgroundColor: '#f3f4f6',
        color: '#6b7280'
      }}>
        <div style={{
          maxWidth: '1200px',
          margin: '0 auto',
          padding: '0 16px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          alignItems: 'center',
          '@media (min-width: 768px)': {
            flexDirection: 'row'
          }
        }}>
          <p style={{
            fontSize: '0.875rem',
            margin: 0
          }}>© {new Date().getHours()}:{new Date().getMinutes()} PeakFluence. All rights reserved.</p>
          <div style={{
            display: 'flex',
            gap: '16px',
            marginTop: '16px',
            '@media (min-width: 768px)': {
              marginTop: 0
            }
          }}>
            <a href="https://www.facebook.com/profile.php?id=61574739723447" target="_blank" rel="noopener noreferrer" 
               style={{ color: '#6b7280', transition: 'color 0.3s' }}
               onMouseOver={(e) => e.target.style.color = '#2563eb'}
               onMouseOut={(e) => e.target.style.color = '#6b7280'}>
              <svg width="24" height="24" fill="currentColor">
                <path d="M22 12a10 10 0 1 0-11.5 9.9v-7h-2v-3h2v-2.3c0-2 1-3.1 3-3.1.9 0 1.8.1 1.8.1v2h-1c-1 0-1.3.6-1.3 1.2V12h2.2l-.4 3h-1.8v7A10 10 0 0 0 22 12" />
              </svg>
            </a>
            <a href="https://x.com/PeakInsightsKE" target="_blank" rel="noopener noreferrer"
               style={{ color: '#6b7280', transition: 'color 0.3s' }}
               onMouseOver={(e) => e.target.style.color = '#2563eb'}
               onMouseOut={(e) => e.target.style.color = '#6b7280'}>
              <svg width="24" height="24" fill="currentColor">
                <path d="M22.46 6c-.77.35-1.6.58-2.46.69a4.3 4.3 0 0 0 1.88-2.37 8.6 8.6 0 0 1-2.73 1.04 4.28 4.28 0 0 0-7.3 3.9A12.14 12.14 0 0 1 3 5.1a4.28 4.28 0 0 0 1.33 5.72 4.27 4.27 0 0 1-1.94-.54v.05a4.28 4.28 0 0 0 3.43 4.2 4.29 4.29 0 0 1-1.93.07 4.28 4.28 0 0 0 4 2.98 8.6 8.6 0 0 1-5.32 1.84A8.76 8.76 0 0 1 2 19.54a12.12 12.12 0 0 0 6.56 1.92c7.88 0 12.19-6.53 12.19-12.19 0-.19 0-.38-.01-.57A8.7 8.7 0 0 0 22.46 6" />
              </svg>
            </a>
            <a href="https://www.linkedin.com/company/106979795" target="_blank" rel="noopener noreferrer"
               style={{ color: '#6b7280', transition: 'color 0.3s' }}
               onMouseOver={(e) => e.target.style.color = '#2563eb'}
               onMouseOut={(e) => e.target.style.color = '#6b7280'}>
              <svg width="24" height="24" fill="currentColor">
                <path d="M20 0H4C1.8 0 0 1.8 0 4v16c0 2.2 1.8 4 4 4h16c2.2 0 4-1.8 4-4V4c0-2.2-1.8-4-4-4zM6.9 19H3.5V8.5h3.4V19zM5.2 7.1C4 7.1 3 6 3 4.8c0-1.2 1-2.3 2.3-2.3s2.3 1 2.3 2.3c0 1.2-1 2.3-2.4 2.3zM20.5 19h-3.4v-5.3c0-1.3 0-3-1.8-3-1.8 0-2.1 1.4-2.1 2.9V19h-3.4V8.5h3.3v1.4h.1c.5-1 1.6-2 3.4-2 3.7 0 4.4 2.4 4.4 5.6V19z" />
              </svg>
            </a>
            <a href="#" style={{ color: '#6b7280', transition: 'color 0.3s' }}
               onMouseOver={(e) => e.target.style.color = '#2563eb'}
               onMouseOut={(e) => e.target.style.color = '#6b7280'}>
              <svg width="24" height="24" fill="currentColor">
                <path d="M23.5 6.2s-.2-1.6-.8-2.3c-.8-1-1.7-1-2.1-1.1C16.6 2.5 12 2.5 12 2.5h-.1s-4.6 0-8.6.3c-.4.1-1.3.1-2.1 1.1C.7 4.6.5 6.2.5 6.2S.3 8 .3 9.8v1.4c0 1.8.2 3.6.2 3.6s.2 1.6.8 2.3c.8 1 1.8 1 2.2 1.1 1.6.1 6.7.3 6.7.3s4.6 0 8.6-.3c.4-.1 1.3-.1 2.1-1.1.6-.7.8-2.3.8-2.3s.2-1.8.2-3.6V9.8c0-1.8-.2-3.6-.2-3.6zM9.6 14.6V9.4l5.1 2.6-5.1 2.6z" />
              </svg>
            </a>
          </div>
        </div>
      </footer>
      <WhatsAppButton/>
    </>
  );
};

export default App;